import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { USER_APIS } from "../../api/apis";
import { post } from "../../shared/AxiosAPI";
import { UserDTO, UserRole, UsersView, USERS_VIEW } from "../../shared/types";
import { isTextboxHasOnlyNumbers, isValidMobileNo } from "../../shared/util/FormValidationUtil";
import { contentCardSx } from "../../../../components/common/surfaceStyles";
import { getInitialUser } from "./UserAPI";

interface UserFormProps {
  user: any;
  gradeSelectionEnabled: boolean;
  setUser: (val: any) => void;
}


export const UserForm = () => {
  const [userRole, setUserRole] = useState<string>(UserRole.STUDENT);
  const [viewState, setViewState] = useState<UsersView>(USERS_VIEW.Add);
  const save = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let formData = new FormData(e.currentTarget);
    if (!isValidMobileNo(formData.get("phone").toString())) {
      alert("Invalid phone no.");
      return;
    }

    let user: UserDTO = getInitialUser();
    user.name = formData.get("name").toString();
    user.gender = formData.get("gender").toString();
    user.mobile = formData.get("phone").toString();
    user.aadhaarNumber = Number.parseInt(formData.get("aadhaarNumber").toString());
    user.roles = [formData.get("userType").toString()];
    // Grades are no longer set here: a faculty's grades come from their teaching assignments.
    user.grades = [];

    try {
      await post(USER_APIS.USERS, null, user);
      setViewState(USERS_VIEW.ADDED)
    } catch (err) {
      alert(err)
    }
  };
  const cancel = () => { };
  return (
    <>
      {viewState === USERS_VIEW.ADDED &&
        <Box display="flex" justifyContent="center" alignItems="center" marginTop={2}>
          <Box
            sx={contentCardSx}
            width={{ xs: "90%", sm: "70%", md: "50%" }}
          >
            <Typography variant="h6" gutterBottom>
              User added successfully.
            </Typography>
          </Box>
        </Box>}
      {
        viewState === USERS_VIEW.Add && (
          <Box display="flex" justifyContent="center" alignItems="center" marginTop={2}>
            <Box
              component="form"
              onSubmit={save}
              sx={contentCardSx}
              width={{ xs: "90%", sm: "70%", md: "50%" }}
              display="flex"
              flexDirection="column"
              gap={2}
            >
              <Typography variant="h6" gutterBottom>
                Enter User Details
              </Typography>

              {/* Name */}
              <Grid>
                <TextField fullWidth required label="Name" size="small" name="name" />
              </Grid>

              {/* Gender */}
              <Grid>
                <FormControl fullWidth>
                  <Select size="small" defaultValue="Male" name="gender">
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Phone */}
              <Grid>
                <TextField fullWidth size="small" required
                  label="Phone"
                  type="text"
                  name="phone"
                  onWheel={(e) => (e.target as HTMLElement).blur()}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (isTextboxHasOnlyNumbers(e.target.value)) {
                      e.currentTarget.value = e.currentTarget.value;
                    }
                  }}
                />
              </Grid>

              {/* Aadhaar */}
              <Grid>
                <TextField size="small" fullWidth label="Aadhaar No" name="aadhaarNumber" />
              </Grid>

              {/* Email */}
              <Grid>
                <TextField size="small" fullWidth label="Email" name="email" />
              </Grid>

              {/* User Type */}
              <Grid>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="userType"
                    defaultValue={UserRole.STUDENT}
                    onChange={(e) => setUserRole(e.target.value)}
                  >
                    {/* Faculty are added through Faculty > Add (they need a staff record and assignments) */}
                    <FormControlLabel value={UserRole.STUDENT} control={<Radio />} label="Student" />
                    <FormControlLabel value={UserRole.ADMIN} control={<Radio />} label="Admin" />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {/* Buttons */}
              <Grid display="flex" gap={2}>
                <Button variant="contained" type="submit" size="small">
                  Submit
                </Button>
              </Grid>
            </Box>
          </Box>)
      }
    </>
  );
};
